import { useState } from 'react';

import { TFunction } from 'i18next';

import { Focusable, Tooltip } from '@cfa/react-core';
import { InfoOutline } from '@cfa/system-icons';

const AnswersChip: React.FC<{ t: TFunction }> = ({ t }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="flex items-center gap-1.5">
      <p
        className="text-variant-h4 text-[#1E272F]"
        data-testid="SmartSearchAnswersChip"
      >
        {t('AISearchPOC.pathwaySmartSearch')}{' '}
        <span className="font-normal">Beta</span>
      </p>
      <Tooltip.Root delay={250} isOpen={isOpen} onOpenChange={setIsOpen}>
        <Focusable>
          <InfoOutline
            className="cursor-pointer"
            onClick={() => setIsOpen(prev => !prev)}
          />
        </Focusable>
        <Tooltip.Content placement="bottom" className="text-variant-body1">
          {t('AISearchPOC.disclaimer')}
        </Tooltip.Content>
      </Tooltip.Root>
    </div>
  );
};

export default AnswersChip;
